export default {
  // general
  'service_settings.update.error':
    'We are unable to update the service at this time. Please try again later.',

  // AWS Load Balancers drawer and stepper
  'service_settings.aws_load_balancers.drawer.stepper.step2': 'Map to ELB',
  'service_settings.aws_load_balancers.drawer.stepper.step3':
    'Enable Intelligent Health Checks',
  'service_settings.aws_load_balancers.drawer.stepper_container.service_update.success':
    'Service updated successfully',
  'service_settings.aws_load_balancers.drawer.stepper_container.service_update.error':
    'There was an error updating the service. Please try again later.',

  // integrations
  'service_settings.integrations.aws_integration.remove.confirmation.dialog.body':
    'All Intelligent Health Checks will be removed from this service, if enabled.',

  // tags
  'service_settings.tags.update.success': 'Service tags successfully updated',
  'service_settings.tags.delete.dialog_title': 'Delete `{{tagName}}`?',
  'service_settings.tags.delete.dialog_body':
    'Are you sure you want to delete tag `{{tagName}}`?',
  'service_settings.tags.description1': 'This service can use custom tags for',
  'service_settings.tags.description2': 'report',
  'service_settings.tags.description3': 'filtering.',
  'service_settings.tags.values.label': 'Values',
  'service_settings.tags.list.empty': 'No tags to display',
  'service_settings.tags.production_environment.checkbox.label.prefix':
    'This Service is in a ',
  'service_settings.tags.production_environment.title':
    'Production Environment',
  'service_settings.tags.production_environment.description':
    'Additional warnings will be shown before any action is taken. This tag can be used to filter reports like custom tags.'
}
